module.exports = __webpack_public_path__ + "img/lv2.70022280.png";